module.exports = __webpack_public_path__ + "img/sjqs.531473a3.png";